import { Truck, Receipt, Package, FileText, Clock, File as FileIcon } from 'lucide-react';

export const SECTION_TITLES = {
  basic: 'Basic Info',
  invoice: 'Invoice',
  status: 'Delivery',
  updated_invoice: 'Updated Inv',
  weight_adjustment: 'Weight Adj',
  billing: 'Billing',
  payment: 'Payment',
};

export const SECTION_FULL_TITLES = {
  basic: 'Basic Information',
  invoice: 'Invoice Details',
  status: 'Delivery & Status',
  updated_invoice: 'Updated Invoice',
  weight_adjustment: 'Weight Adjustment',
  billing: 'Billing & Follow-up',
  payment: 'Payment Tracking',
};

export const SECTION_ICONS = {
  basic: Truck,
  invoice: Receipt,
  status: Package,
  updated_invoice: FileText,
  weight_adjustment: Receipt,
  billing: Receipt,
  payment: Clock,
  other_bills: FileIcon,
};
